import script from "./Input.vue?vue&type=script&setup=true&lang=ts"
export * from "./Input.vue?vue&type=script&setup=true&lang=ts"

import "./Input.vue?vue&type=style&index=0&id=48945d83&lang=css"

const __exports__ = script;

export default __exports__